import { DecimalPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookModel } from '@shared/model/bookModels/book-model';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';

@Component({
  selector: 'beh-share-book-dialog',
  imports: [
    ImagePipe,
    DecimalPipe
  ],
  templateUrl: './share-book-dialog.component.html',
  styleUrl: './share-book-dialog.component.scss'
})
export class ShareBookDialogComponent implements OnInit {
  data = inject<BookModel>(MAT_DIALOG_DATA);

  imageType = EImageType
  firstAuthor!: string;
  firstTranslator!: string;

  ngOnInit(): void {
      this.firstAuthor = this.data.authors?.find(a => a.type === 'Author')?.name!;
      this.firstTranslator = this.data.authors?.find(a => a.type === 'Translator')?.name!;

  }
}
